import { ApiProperty } from '@nestjs/swagger'
import { IsArray, IsUUID, ArrayMinSize, ArrayMaxSize } from 'class-validator'

/**
 * DTO pour trouver plusieurs utilisateurs par leurs IDs
 */
export class FindUsersByIdsDto {
  @ApiProperty({
    description: 'Liste des IDs utilisateurs à récupérer',
    type: [String],
    example: ['uuid-1', 'uuid-2'],
    minItems: 1,
    maxItems: 100,
  })
  @IsArray()
  @IsUUID('4', { each: true })
  @ArrayMinSize(1)
  @ArrayMaxSize(100)
  ids!: string[]
}
